<template>
  <div>
    <navMenu />

    <section
      class="jsk-block hero-block d-flex"
       :style="{
        'background-image':
          'url(' + require('./../assets/images/heroes/home-hero.png') + ')'
      }"

    >
      
      <div class="container home-block d-flex align-items-center position-relative">
        <div class="row jsk-block-round bg-secondary position-absolute bedind"></div>
        <div class="row">
          <div class="col-12 col-md-12 col-lg-8 offset-lg-2 text-center">
            <h6 class="mb-2 text-uppercase text-title">{{ $t("home.subtitle") }}</h6>
            <h1 class="font-family-base mb-4">{{ $t("home.title") }}</h1>
            <div class="mt-5">
              <a href="#services"
                
                class="btn btn-xl btn-primary btn-round mr-2 text-uppercase mt-3"
              >{{ $t("home.discoverBtn") }}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import navMenu from "./navMenu.vue";

export default {
  name: "HeroHome",
  components: {
    navMenu
  }
};
</script>
